




















import Vue from 'vue'
import moment from 'moment'

import { AllMessagesInCaseAfterQuery, AllMessagesInCaseAfterQueryVariables } from '@/graphql-schema'
import { AllCases } from '@/queries/cases.graphql'
import { Case } from '@/store/cases-module'

import AuthorizationMixin from '@/routing/AuthorizationMixin'
import { AllMessagesInCaseAfter } from '@/queries/caseMessages.graphql'
import { NotNull } from '@/utils'

export default Vue.extend({
  mixins: [AuthorizationMixin],
  apollo: {
    caseMessages: {
      query: AllMessagesInCaseAfter,
      pollInterval: 30000,
      skip() {
        return !(this as any).isAuthorized || !this.$store.getters.currentCaseId
      },
      variables(): AllMessagesInCaseAfterQueryVariables {
        return {
          caseId: this.currentCase.id,
          timestamp: this.currentCase.myInvolvement.newMessagesAfter,
        }
      },
    },
  },
  computed: {
    currentCase(): any {
      return this.$store.getters.currentCase
    },
    numberOfMessages(): number {
      return this.caseMessages!.nodes.length || 0
    },
  },
  data(): {
    caseMessages: AllMessagesInCaseAfterQuery['caseMessages']
  } {
    return {
      caseMessages: { nodes: [] },
    }
  },
})
